import logo from './logo.svg';
import './App.css';

import React from 'react';
import ReactDOM from 'react-dom';



//import 'bootstrap/dist/css/bootstrap.min.css';

import './custom.scss';

import Alert from 'react-bootstrap/Alert';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import OK from './OK.js';

import DoubleNegative from './Questions/DoubleNegative.js';
import Shame from './Questions/Shame.js';
import Simple from './Questions/Simple.js';
import Neither from './Questions/Neither.js';
import Timing from './Questions/Timing.js';
import TouchDown from './Questions/TouchDown.js';
import SmallPrint from './Questions/SmallPrint.js';
import MultiColumn from './Questions/MultiColumn.js';
import SneakySub from './Questions/SneakySub.js';
import ColorCode from './Questions/ColorCode.js';
import Hair from './Questions/Hair.js';
import ThreeButtons from './Questions/ThreeButtons.js';
import Spin from './Questions/Spin.js';

import Message from './Message.js';

import About from './About.js';



import SlideUp from './SlideUp';


import Intro from './Intro.js';


import BadDesign from './BadDesign.js';



import YouWin from './YouWin.js';
import YouLose from './YouLose.js';

import ScoreCard from './ScoreCard.js';


//import useSound from 'use-sound';


import AllQuestions from './Questions/AllQuestions.js';


import {Howl, Howler} from 'howler';





class App extends React.Component {




    constructor(props) {
      super(props);
      this.state = {


        not_started: true,

        num_answered_questions: 0,

        correct_incorrect_list: [],

        between_questions: false,

        quiz_over: false,

        loading_jitter: 2.5,
        question_types: [],
        question_types_counts: [],
        youlose: false,
        questions: [],
        all_questions: [[]],
        current_question: 0,
        fail_message:"",
        answeredQuestions: [],
        score: [],
        total_score: [],
        questionStartTime: Date.now(),
        streak: 0,
        successSound: new Howl({src: ['./sounds/success.mp3']}),
        failSound: new Howl({src: ['./sounds/fail2.mp3']}),
        popSound: new Howl({src: ['./sounds/pop2.mp3']}),
        levelupSound: new Howl({src: ['./sounds/levelup.mp3']}),
        current_level: 0,
        
        background: "rgba(0.5, 0.5, 0.5, 0.35)",
        background_original: "rgba(0.5, 0.5, 0.5, 0.35)",
        background_success: "#5de76f",
        background_fail: "#f3224f",

        message: "jiggle",
        message_original: "",
        message_success: "No personal data received",
        message_fail: "Thanks for your data",
        message_end: "The End",
        
        
        all_fails: [],
        fails: [],
        failed_questions: [],


    


        start: (result, question) => {

                //console.log("start")

                window.plausible('start');

                

                


                this.setState({
                  questions: [],
                  not_started: false
                
                })


                this.interval = setInterval(() => {


                    //console.log("doig")
                    
                    if(Math.random()*this.state.loading_jitter < 1)
                    {
                      if(this.state.questions.length < this.state.all_questions[this.state.current_level].length)
                        {
                            this.setState({questions: this.state.all_questions[this.state.current_level].slice(0, this.state.questions.length+1)})

                            this.state.popSound.play();

                            this.setState({ 
                              message: "jiggle"
                            })
                        }
                        else
                        {
                            clearInterval(this.interval);

                            //console.log("done adding")

                            this.setState({ 
                              questionStartTime: Date.now()+250,
                              message: ""
                            
                            })


                            

                        }


                    }
                  
                }, 50);

              }



      };

      
    }

  

 
    componentWillUnmount() {
        clearInterval(this.interval);
      }


    componentDidMount() {

      window.plausible('loaded');


      setTimeout(() => {

        this.setState({ 
          message: this.state.message_original
        })

      },2500)

     
        
        this.setState({ 
          
          
        })


      

       const setResult = (result, question) => {

        window.plausible('answered_' + this.state.num_answered_questions);

        this.setState({
          num_answered_questions: this.state.num_answered_questions + 1
        })


        this.setState({between_questions: true})


        if(result)
        {
          window.plausible("correct", {props: { question: this.state.questions.length-1 }});
        }
        else
        {
          window.plausible("incorrect", {props: { question: this.state.questions.length-1 }});
        }

          


          //console.log("result: ", result)
          //console.log("question: ", question);
        

          if(question != this.state.questions[this.state.questions.length-1])
          {
            //console.log("no skipping!")
          }

          
          var multiplier = 1;
          var timeTaken = Date.now() - this.state.questionStartTime;



          var score = {amount:0, time: timeTaken, multiplier: multiplier, types: question.props.types};

          if(timeTaken < 1000)
          {
            timeTaken = 1000;
          }


          
          

          if(result)
          {


            //got it right
          
            

            var previousScore = this.state.score.slice(-1)[0]
            
            if(previousScore)
            {
                if(previousScore.amount > 0)
                {
                  //got the previous question right too.

                  this.setState({
                    streak: this.state.streak + 1
                  })

                  
                }
            }
            

            

            if(this.state.streak > 4)
            {
              multiplier = 2
            }
            if(this.state.streak > 8)
            {
              multiplier = 4
            }

            score.multiplier = this.state.streak // just make it direct
            




            var rate = (this.state.streak)/10 + 0.5

            if(rate > 10)
            {
              rate = 10
            }

            let soundId = this.state.successSound.play();

            this.state.successSound.rate(rate, soundId);

            this.setState({

              correct_incorrect_list: this.state.correct_incorrect_list.concat([1]),

              message: this.state.message_success,
              background: this.state.background_success

            })

             
            //calculate score

             score.amount = 1

          }

          else
          {

            //got it wrong
            //this.state.failSound.play();



            let soundId = this.state.failSound.play();

            this.state.successSound.rate(rate, soundId);

            this.setState({
              background: this.state.background_fail,
              message: this.state.message_fail,

            })


            //console.log("got it wrong: ", this.state.questions.length-1)

             this.setState({


              correct_incorrect_list: this.state.correct_incorrect_list.concat([0]),

                streak: 0,
                fails: this.state.fails.concat(question.props.fail_message),
                all_fails: this.state.all_fails.concat(question.props.fail_message),

                failed_questions: this.state.failed_questions.concat(this.state.questions.length-1)
             })

           

          }
         

            this.setState({
              score: this.state.score.concat(score),
              total_score: this.state.total_score.concat(score)
            })
           
            this.setState({

              //remember that we answered this question - this will make it start animating off screen
              answeredQuestions: this.state.answeredQuestions.concat(this.state.questions[this.state.questions.length-1])
              //questions: this.state.questions.slice(0, -1),
              //current_question:  this.state.questions[this.state.questions.length-1],
            
            })


             this.setState({
                      
                    
                        questionStartTime: Date.now()
                    
                    })

            
                    setTimeout(() => { 


                      //actually remove the question from the questions array
                      this.setState({
                                      
                        questions: this.state.questions.slice(0, -1),
                        current_question: this.state.questions[this.state.questions.length-1],
                     
                    
                    })
      
      
      
      
                  }, 300)

                  setTimeout(() => { 


                      //actually remove the question from the questions array
                      this.setState({
                                      
                      
                        background: this.state.background_original,
                        message: this.state.message_original,
                        between_questions: false,
                    
                    })

                    this.checkIfLevelOver(this)



                  }, 700)


            

            //console.log(this.state.answeredQuestions.length);

            window.correct_incorrect_list = this.state.correct_incorrect_list

            console.log("correct_incorrect_list", this.state.correct_incorrect_list)


        };



    


         const getPos = (question) => {

          if(this.state.between_questions == true)
          {
            //return 10
          }


           //if it's been answered, move it to the side

           for(var i = 0; i < this.state.answeredQuestions.length; i ++)
           {
             if(question.props == this.state.answeredQuestions[i].props)
             {
               return -30
             }
           }


          //if it is in the questions array theh display in its proper position depending where in the array it is
           
           for(var i = 0; i < this.state.questions.length; i ++)
           {
             if(question.props == this.state.questions[i].props)
             {
               return this.state.questions.length - i - 1
             }
           }


          //catch all, just move it away
           return -70
          
          


        };




      this.checkIfLevelOver = function(that)
      {
        
          // see if we have any questions left
          if(that.state.questions.length == 0)
          {
            //used all the questions for this level, let's level up

            
            that.setState({
              
                current_level: that.state.current_level + 1,
            
            })

            that.state.levelupSound.play()



            if(that.state.current_level < that.state.all_questions.length)
            {
              //we have another level - this should never happen, it's all one level now.


              /*
              console.log("have another level")

              


              that.setState({
              
                  questions: [<ScoreCard title="" fails={that.state.fails} continue={that.state.start} score={that.state.score} question_types_counts={this.state.question_types_counts}></ScoreCard>],
                  current_question: that.state.questions[0],
                  fails: [],
                  score: [],
                  streak: 0
              
              })

              */

              //hopefully this will get filled automatically by the timer now we've levelled up

            }

            else
            {
              //it's the end

              that.setState({
                message: that.state.message_end
              })


              setTimeout(() => {

              
                that.setState({
              
                  questions: [<ScoreCard correct_incorrect_list={this.state.correct_incorrect_list} title="Thanks for visiting Evil Corp" failed_questions={that.state.failed_questions} fails={that.state.all_fails} continue={false} score={that.state.total_score} question_types_counts={this.state.question_types_counts} question_types={this.state.question_types}   ></ScoreCard>],
                  current_question: that.state.questions[0],

                  quiz_over: true
              
                })


              }, 1600)

             
            }

          //console.log("all fails length: ", that.state.all_fails.length)

            
          }


      }
      

      


      this.answerAll = () => {

        this.setState({loading_jitter: 0})

        this.state.start()

      

        setInterval(() => {

          if(this.state.questions.length > 1)
          {
            setResult(Math.round(Math.random()*1), this.state.questions[this.state.questions.length-1])
          }
          

        }, 501)
        

      }




      this.next = () => {

        clearInterval(this.interval);

        //console.log("next")

        this.setState({
                                
          questions: this.state.questions.slice(0, 0),
          current_question: false,

          current_level: this.state.current_level + 1,
      
        })

       

        this.state.start()

      }


      this.back = () => {

        clearInterval(this.interval);

        //console.log("back")

        this.setState({
                                
          questions: this.state.questions.slice(0, 0),
          current_question: false,

          current_level: this.state.current_level - 1,
      
        })

       

        this.state.start()

      }


      
      var all_questions = AllQuestions(setResult, getPos)



        //count types of questions

        //console.log("question types:", all_questions)

        var all_types = []

        for(var i = 0; i < all_questions[this.state.current_level].length; i++)
        {
          
            //console.log(i + ": " + all_questions[this.state.current_level][i].props.types)
            
            var these_types = all_questions[this.state.current_level][i].props.types

            for(var t = 0; t < these_types.length; t++)
            {
              all_types.push(these_types[t])
            }

          
        }

        //now let's see how many of each question type we have

        var question_types_counts = {};

        for (var i = 0; i < all_types.length; i++) {
          var num = all_types[i];
          question_types_counts[num] = question_types_counts[num] ? question_types_counts[num] + 1 : 1;
        }



        //console.log("counts:",question_types_counts)



      //define all the questions - has to happen in here so we can reference setResult
      this.setState({
        question_types: all_types,
        question_types_counts: question_types_counts,
        
        questions:  [<SlideUp
        
          setResult={this.state.start}
        
        
        >
              

                
              
              </SlideUp>].reverse(),
        
        all_questions: all_questions})




      


        
      }


    render() {


    //this gets called by the question components (DoubleNegative etc). true if answered correctly, false if incorrect, 
    //So we don't need to worry about any right or wrong logic, the question component owns that

   
  /*
  if(this.state.youlose == true)
  {

      //game over was set after a question component eturned false to setResult, so now we need to show game over
      return (

        <YouLose fail_message={this.state.fail_message} dodged={this.state.answeredQuestions.length}></YouLose>
        
      );
  }
  else
  {
    */

    const getMessage = () => {
      return this.state.message
    }


    var buttons = []

    if(this.state.current_level > 0)
    {
      buttons.push(<div className="noselect" onClick={this.back} id="back">&#60;</div>)
    }

    if(this.state.current_level < this.state.all_questions.length-1)
    {
      buttons.push( <div className="noselect" onClick={this.next} id="next">&#62;</div>)
    }


       
    //handle the click on one of the buttons
    const handleFeaturedClick = (e) => {

        window.open("https://www.theguardian.com/science/2021/may/17/can-you-solve-it-are-you-smart-enough-to-opt-out-of-cookies")
         
 
     };


    var featured = <div></div>
     

    if(this.state.not_started || this.state.quiz_over)
    {
      featured = <a onClick={handleFeaturedClick}><img id="featured" src="./featured.png"></img></a>
    }


    var bad_design = <div></div>

    if(this.state.quiz_over == false)
    {

      //console.log("getMessage", getMessage)

      bad_design = <BadDesign getMessage={getMessage}></BadDesign>
    }

            //game is not over, so lets show the current question from the questions array
            return (

              
                  <header className="App-header">
                    
                  {bad_design}


                 


                   
                  
                    {this.state.questions}

                    
                    {featured}
                    
                    <About></About> 

                  
                   
                      
                    
                  </header>
              
              );
        
      
    /*}*/
    


  }
                 

}




export default App;
